import { render, staticRenderFns } from "./documentosElectronicosView.vue?vue&type=template&id=780fec29"
import script from "./documentosElectronicosView.vue?vue&type=script&lang=js"
export * from "./documentosElectronicosView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports